import { createFileRoute } from "@tanstack/react-router";
import { SaleDetailPage } from "@/components/sales/SaleDetailPage";
import { requireAuth } from "@/lib/require-auth";

export const Route = createFileRoute("/sales_/$saleId")({
  beforeLoad: () => {
    requireAuth();
  },
  component: SaleDetailPage,
});
